import React from 'react';
import {
    FiltersGamesListMobileComponent
} from "../../../../components/filters/filters-games-list-mobile/filters-games-list-mobile.component";
import {SimpleStrategyFiltersEditor} from "./simple-strategy-filters-editor";
import {GamesFilterStrategyBase} from "../games-filter-strategy-base";
import {OtherFiltersCategoryDefinition} from "../../filters-categories-definitions/other.filters-category-definition";
import {StaticArenaGameFiltersCategory} from "../../arena-filters/categories/static-arena-game-filters-category";
import {IArenaGameFiltersCategory} from "../../arena-filters/categories/arena-game-filters-category.interface";
import {Lazy} from "../../../../../utils/Lazy";
import {IGameFilterEvaluator} from "../../evaluators/game-filter-evaluator.interface";
import {OR} from "../../evaluators/or-game-filters-evaluator";
import {AND} from "../../evaluators/and-game-filters-evaluator";
import {
    FiltersMobileButtonComponent
} from "../../../../components/header/top-header-left/filters/filters-mobile-button.component";
import {
    IPcFilterIndicatorRenderingOptions,
    PcFilterIndicatorRenderingLocation
} from "../../games-filter.service.interface";
import {
    FiltersGamesListPcComponent
} from "../../../../components/filters/filters-games-list-pc/filters-games-list-pc.component";
import {Nullable} from "../../../../../common/types/nullable-types";
import {FilterCategoryDefinitionFactory} from '../../filters-categories-definitions/filter-category-definition-factory';
import {AdhocArenaGamesFiltersCategory} from "../../arena-filters/categories/adhoc-arena-games-filters-category";

export class SimpleGamesFilterStrategy extends GamesFilterStrategyBase {

    private _factory = new FilterCategoryDefinitionFactory(this.services);

    private _vendorCategory = new Lazy(() => new StaticArenaGameFiltersCategory(this._factory.createCategoryDefinition("vendors"), this.services));
    private _groupCategory = new Lazy(() => new StaticArenaGameFiltersCategory(this._factory.createCategoryDefinition("gameGroups"), this.services));
    private _featuresCategory = new Lazy(() => new StaticArenaGameFiltersCategory(this._factory.createCategoryDefinition("features"), this.services));
    private _othersCategory = new Lazy(() => new StaticArenaGameFiltersCategory(new OtherFiltersCategoryDefinition([this._vendorCategory.value, this._groupCategory.value, this._featuresCategory.value], this.services), this.services));
    private _adhocCategory = new Lazy(() => new AdhocArenaGamesFiltersCategory(this.services));

    protected _createFiltersCategories(): IArenaGameFiltersCategory[] {
        return [
            this._vendorCategory.value,
            this._groupCategory.value,
            this._featuresCategory.value,
            this._othersCategory.value,
            this._adhocCategory.value
        ];
    }

    protected _createEvaluator(): IGameFilterEvaluator | null {
        return OR(AND(this._vendorCategory.value,
                      this._groupCategory.value,
                      this._featuresCategory.value,
                      this._adhocCategory.value),
            this._othersCategory.value);
    }

    private _createFiltersEditor(): SimpleStrategyFiltersEditor {
        return new SimpleStrategyFiltersEditor(this.filtersCategories, this.services);
    }

    showFiltersEditor(): void {
        this.services.dialog.showModal((dialogHandler) => <FiltersGamesListMobileComponent dialogHandler={dialogHandler} filtersEditor={this._createFiltersEditor()}/>, {
            title: this.services.translation.translate('FILTER'),
            mobileCenterHeader: true,
            applyMaxHeight: true
        });
    }

    renderMobileFiltersIndicator(): React.ReactElement {
        if(this.services.mediaQuery.lAndBelow) {
            return (<FiltersMobileButtonComponent/>);
        } else {
            return null;
        }

    }

    renderPCFiltersIndicator(): Nullable<IPcFilterIndicatorRenderingOptions> {
        if(this.services.mediaQuery.lAndBelow) {
            return null;
        } else {
            return {
                location: PcFilterIndicatorRenderingLocation.BelowArenaTitle,
                reactElement: (<FiltersGamesListPcComponent filtersEditor={this._createFiltersEditor()}/>)
            };
        }
    }


}